import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Box,
  Slider,
  Alert,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  useTheme,
  InputAdornment,
  useMediaQuery,
  TableContainer,
  Menu,
  ListItemIcon,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Pagination,
  Grid,
  Chip,
  Breadcrumbs,
  Link as MUILink,
  Divider,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DiscountIcon from "@mui/icons-material/Discount";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useDispatch, useSelector } from "react-redux";
import { getAllBuyerCategories } from "../redux/slices/buyerCategoriesSlice";
import {
  getAllSellerCategories,
  createSellerCategory,
} from "../redux/slices/sellerCategoriesSlice";
import {
  getUserProducts,
  addProduct,
  updateProduct,
  deleteProduct,
  getProductsByBuyerCategoryId,
  updateProductBuyerCategoryVisibility,
  hideProductsByBuyerCategory,
  applyGlobalDiscount,
} from "../redux/slices/sellerProductSlice";
// import DownloadCSV from "./DownloadCSV";
import ConfirmDialog from "../Components/ConfirmDialog";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../Components/PageTitle";

export default function Catalog() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  // State for dropdowns
  const [buyerCategoryAnchorEl, setBuyerCategoryAnchorEl] = useState(null);
  const [sellerCategoryAnchorEl, setSellerCategoryAnchorEl] = useState(null);
  const [selectedBuyerCategory, setSelectedBuyerCategory] =
    useState("MRP Catalog");
  const [selectedSellerCategory, setSelectedSellerCategory] = useState("All");
  const [selectedBuyerCategoryId, setSelectedBuyerCategoryId] = useState(null);

  // Search state
  const [searchQuery, setSearchQuery] = useState("");

  // Buyer categories pagination state
  const [buyerCategoriesPage, setBuyerCategoriesPage] = useState(1);
  const [buyerCategoriesLimit] = useState(10);
  const [loadedBuyerCategories, setLoadedBuyerCategories] = useState([]);
  const [hasMoreBuyerCategories, setHasMoreBuyerCategories] = useState(true);
  // Seller categories pagination state
  const [sellerCategoriesPage, setSellerCategoriesPage] = useState(1);
  const [sellerCategoriesLimit] = useState(10);
  const [loadedSellerCategories, setLoadedSellerCategories] = useState([]);
  const [hasMoreSellerCategories, setHasMoreSellerCategories] = useState(true);

  // CLIENT-SIDE pagination state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // State for ALL products (no pagination from API)
  const [allProductsLoaded, setAllProductsLoaded] = useState([]);

  // Change Price dialog states
  const [openChangePrice, setOpenChangePrice] = useState(false);
  const [changePriceProduct, setChangePriceProduct] = useState(null);
  const [newPrice, setNewPrice] = useState("");

  // Global Discount dialog states
  const [openGlobalDiscount, setOpenGlobalDiscount] = useState(false);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [currentAverageDiscount, setCurrentAverageDiscount] = useState(0);
  const [currentBuyerDiscount, setCurrentBuyerDiscount] = useState(0);

  // Redux states
  const {
    categories: buyerCategories = [],
    loading: buyerCategoriesLoading,
    page: buyerCategoriesCurrentPage = 1,
    totalPages: buyerCategoriesTotalPages = 1,
  } = useSelector((state) => state.buyerCategories);

  const {
    categories: sellerCategories = [],
    loading: sellerCategoriesLoading,
    page: sellerCategoriesCurrentPage = 1,
    total: sellerCategoriesTotal = 0,
    totalPages: sellerCategoriesTotalPages = 1,
  } = useSelector((state) => state.sellerCategory);

  const {
    userProducts = [],
    loading: productLoading,
    productsByBuyerCategory: productsByBuyerCategoryData = [],
  } = useSelector((state) => state.products);

  // Check if MRP Catalog and All are selected
  const isMRPCatalogAndAllSelected =
    selectedBuyerCategory === "MRP Catalog" && selectedSellerCategory === "All";

  // Product form states
  const [addProductCategories, setAddProductCategories] = useState([]);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [newProduct, setNewProduct] = useState({
    name: "",
    category: "",
    mrp: "",
    description: "",
    specifications: "",
    image: "",
    imageFile: null,
    unit: "",
    customUnit: "",
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [openUploadXLSX, setOpenUploadXLSX] = useState(false);
  const [xlsxFile, setXlsxFile] = useState(null);
  const [xlsxData, setXlsxData] = useState([]);

  // Edit Product form states
  const [editProductId, setEditProductId] = useState(null);
  const [editProduct, setEditProduct] = useState({
    name: "",
    unit: "",
    customUnit: "",
    category: null,
    mrp: "",
    price: "",
    description: "",
    specifications: "",
    image: "",
    imageFile: null,
  });
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [actionProductId, setActionProductId] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: null,
  });

  // Load initial buyer categories
  useEffect(() => {
    dispatch(getAllBuyerCategories({ page: 1, limit: buyerCategoriesLimit }));
  }, [dispatch, buyerCategoriesLimit]);

  // Load initial seller categories
  useEffect(() => {
    dispatch(getAllSellerCategories({ page: 1, limit: sellerCategoriesLimit }));
  }, [dispatch, sellerCategoriesLimit]);

  // **FIX: Load ALL products without pagination**
  useEffect(() => {
    if (selectedBuyerCategory === "MRP Catalog") {
      // Fetch all products (use large limit like 10000)
      dispatch(getUserProducts({ page: 1, limit: 10000 }));
    }
  }, [dispatch, selectedBuyerCategory]);

  // **FIX: Load ALL products by buyer category**
  useEffect(() => {
    if (selectedBuyerCategoryId) {
      dispatch(
        getProductsByBuyerCategoryId({
          buyerCategoryId: selectedBuyerCategoryId,
          page: 1,
          limit: 10000, // Fetch all
        }),
      );
    }
  }, [dispatch, selectedBuyerCategoryId]);

  // **FIX: Store all loaded products**
  useEffect(() => {
    if (selectedBuyerCategory === "MRP Catalog") {
      setAllProductsLoaded(userProducts || []);
    } else {
      setAllProductsLoaded(productsByBuyerCategoryData || []);
    }
  }, [selectedBuyerCategory, userProducts, productsByBuyerCategoryData]);

  // Update loaded buyer categories when data changes
  useEffect(() => {
    if (buyerCategories.length > 0) {
      if (buyerCategoriesPage === 1) {
        setLoadedBuyerCategories(buyerCategories);
      } else {
        setLoadedBuyerCategories((prev) => [...prev, ...buyerCategories]);
      }
      setHasMoreBuyerCategories(
        buyerCategoriesCurrentPage < buyerCategoriesTotalPages,
      );
    }
  }, [
    buyerCategories,
    buyerCategoriesPage,
    buyerCategoriesCurrentPage,
    buyerCategoriesTotalPages,
  ]);

  // Update loaded seller categories when data changes
  useEffect(() => {
    if (sellerCategories.length > 0) {
      if (sellerCategoriesPage === 1) {
        setLoadedSellerCategories(sellerCategories);
      } else {
        setLoadedSellerCategories((prev) => [...prev, ...sellerCategories]);
      }
      setHasMoreSellerCategories(
        sellerCategoriesCurrentPage < sellerCategoriesTotalPages,
      );
    }
  }, [
    sellerCategories,
    sellerCategoriesPage,
    sellerCategoriesCurrentPage,
    sellerCategoriesTotalPages,
  ]);

  // **FIX: CLIENT-SIDE FILTERING AND SEARCHING**
  const filteredProducts = useMemo(() => {
    if (!allProductsLoaded || allProductsLoaded.length === 0) return [];

    let result = [...allProductsLoaded];

    // Apply category filter
    if (selectedSellerCategory !== "All") {
      result = result.filter(
        (p) => p.category?.name === selectedSellerCategory?.name,
      );
    }

    // Apply search filter
    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase().trim();
      result = result.filter((product) => {
        return (
          product.name?.toLowerCase().includes(query) ||
          product.category?.name?.toLowerCase().includes(query) ||
          product.description?.toLowerCase().includes(query) ||
          product.specifications?.toLowerCase().includes(query)
        );
      });
    }

    return result;
  }, [allProductsLoaded, selectedSellerCategory, searchQuery]);

  // **FIX: CLIENT-SIDE PAGINATION**
  const paginatedProducts = useMemo(() => {
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    return filteredProducts.slice(startIndex, endIndex);
  }, [filteredProducts, page, limit]);

  // **FIX: Calculate total pages**
  const totalPages = useMemo(() => {
    return Math.ceil(filteredProducts.length / limit) || 1;
  }, [filteredProducts.length, limit]);

  // **FIX: Reset to page 1 when filter or search changes**
  useEffect(() => {
    setPage(1);
  }, [selectedBuyerCategory, selectedSellerCategory, searchQuery]);

  // Handle buyer category dropdown
  const handleBuyerCategoryDropdownOpen = (event) => {
    setBuyerCategoryAnchorEl(event.currentTarget);
  };

  const handleBuyerCategoryDropdownClose = () => {
    setBuyerCategoryAnchorEl(null);
  };

  // Handle seller category dropdown
  const handleSellerCategoryDropdownOpen = (event) => {
    setSellerCategoryAnchorEl(event.currentTarget);
  };

  const handleSellerCategoryDropdownClose = () => {
    setSellerCategoryAnchorEl(null);
  };

  // Load more buyer categories
  const loadMoreBuyerCategories = () => {
    const nextPage = buyerCategoriesPage + 1;
    setBuyerCategoriesPage(nextPage);
    dispatch(
      getAllBuyerCategories({ page: nextPage, limit: buyerCategoriesLimit }),
    );
  };

  // Load more seller categories
  const loadMoreSellerCategories = () => {
    const nextPage = sellerCategoriesPage + 1;
    setSellerCategoriesPage(nextPage);
    dispatch(
      getAllSellerCategories({ page: nextPage, limit: sellerCategoriesLimit }),
    );
  };

  // **FIX: Handle page change**
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // **FIX: Handle limit change**
  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value);
    setLimit(newLimit);
    setPage(1);
  };

  // Handle search change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchQuery("");
  };

  // Buyer category selection handler
  const handleBuyerCategorySelect = async (category) => {
    if (category === "MRP Catalog") {
      setSelectedBuyerCategory("MRP Catalog");
      setSelectedBuyerCategoryId(null);
    } else {
      setSelectedBuyerCategory(category.name);
      setSelectedBuyerCategoryId(category._id);
    }
    setSelectedSellerCategory("All");
    setSearchQuery("");
    setPage(1);
    handleBuyerCategoryDropdownClose();
  };

  // Seller category selection handler
  const handleSellerCategorySelect = (category) => {
    if (category === "All") {
      setSelectedSellerCategory("All");
    } else {
      setSelectedSellerCategory(category);
    }
    setSearchQuery("");
    setPage(1);
    handleSellerCategoryDropdownClose();
  };

  const handleDownloadSample = () => {
    const link = document.createElement("a");
    link.href = "/downloaded_sample.xlsx";
    link.download = "product_sample.xlsx";
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  };

  // XLSX Upload Handlers
  const handleUploadXLSXOpen = () => {
    setOpenUploadXLSX(true);
    setXlsxFile(null);
    setXlsxData([]);
    setUploadProgress(0);
  };

  const handleUploadXLSXClose = () => {
    setOpenUploadXLSX(false);
    setXlsxFile(null);
    setXlsxData([]);
    setUploadProgress(0);
  };

  const handleXLSXFileSelect = async (event) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.name.endsWith(".xlsx") ||
        file.name.endsWith(".xls"))
    ) {
      setXlsxFile(file);
      await parseXLSXFile(file);
    } else {
      toast.info("Please select a valid Excel file (.xlsx or .xls)");
    }
  };

  const parseXLSXFile = async (file) => {
    try {
      const XLSX = await import("xlsx");
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        if (jsonData.length === 0) {
          toast.info("Excel file is empty");
          return;
        }

        const parsedData = jsonData
          .map((row) => {
            const rawImage = String(row.image || "").trim();
            const isValidUrl =
              rawImage.startsWith("http://") ||
              rawImage.startsWith("https://") ||
              rawImage.startsWith("data:image");

            return {
              name: String(row.name || "").trim(),
              category: String(row.category || "").trim(),
              mrp: row.mrp ? String(row.mrp).trim() : "0",
              description: String(row.description || "").trim(),
              specifications: String(row.specifications || "").trim(),
              unit: String(row.unit || "").trim(),
              image: isValidUrl ? rawImage : "",
            };
          })
          .filter((p) => p.name && p.category);

        if (parsedData.length === 0) {
          toast.warning(
            "No valid rows found. Check Name and Category columns.",
          );
        } else {
          setXlsxData(parsedData);
        }
      };
      reader.readAsArrayBuffer(file);
    } catch (error) {
      toast.error("Error reading Excel file.");
    }
  };

  const handleBulkUpload = async () => {
    if (!xlsxData.length) {
      toast.warning("No valid data to upload");
      return;
    }

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const totalProducts = xlsxData.length;
      let successCount = 0;

      const categoryMap = new Map();
      loadedSellerCategories.forEach((cat) => {
        categoryMap.set(cat.name.toLowerCase(), {
          id: cat._id,
          name: cat.name,
          originalName: cat.name,
          status: "existing",
        });
      });

      const uniqueCategories = [
        ...new Set(xlsxData.map((p) => p.category.trim())),
      ];
      const categoriesToCreate = uniqueCategories.filter(
        (catName) => !categoryMap.has(catName.toLowerCase()),
      );

      if (categoriesToCreate.length > 0) {
        toast.info(`Creating ${categoriesToCreate.length} new categories...`);

        for (const catName of categoriesToCreate) {
          try {
            const payload = {
              name: catName,
              gst: 0,
              image: "",
              hsnCode: "",
            };

            const response = await dispatch(
              createSellerCategory(payload),
            ).unwrap();

            if (
              response &&
              response.success &&
              response.data &&
              response.data._id
            ) {
              categoryMap.set(catName.toLowerCase(), {
                id: response.data._id,
                name: response.data.name,
                originalName: catName,
                status: "created",
              });
              setLoadedSellerCategories((prev) => [...prev, response.data]);
            } else {
              throw new Error(
                `Invalid API response: ${JSON.stringify(response)}`,
              );
            }

            await new Promise((resolve) => setTimeout(resolve, 300));
          } catch (catError) {
            categoryMap.set(catName.toLowerCase(), {
              id: null,
              name: catName,
              originalName: catName,
              status: "failed",
              error: catError.message || "Unknown error",
            });
            toast.error(`Failed: ${catName}`);
          }
        }
      }

      const productsToUpload = [];
      const skippedProducts = [];

      xlsxData.forEach((product) => {
        const categoryName = product.category.trim();
        const categoryKey = categoryName.toLowerCase();
        const categoryInfo = categoryMap.get(categoryKey);

        if (
          categoryInfo &&
          categoryInfo.id &&
          (categoryInfo.status === "existing" ||
            categoryInfo.status === "created")
        ) {
          productsToUpload.push({
            ...product,
            categoryInfo: categoryInfo,
          });
        } else {
          const reason = categoryInfo
            ? categoryInfo.error || "Category creation failed"
            : "Category not found";

          skippedProducts.push({
            product: product.name,
            category: categoryName,
            reason: reason,
          });
        }
      });

      if (productsToUpload.length > 0) {
        toast.info(`Uploading ${productsToUpload.length} products...`);

        for (let i = 0; i < productsToUpload.length; i++) {
          const item = productsToUpload[i];

          try {
            const formData = new FormData();
            formData.append("name", item.name);
            formData.append("category", item.categoryInfo.id);
            formData.append("mrp", item.mrp);
            formData.append("description", item.description);
            formData.append("specifications", item.specifications);
            formData.append("unit", item.unit);
            formData.append("image", item.image);

            await dispatch(addProduct(formData)).unwrap();
            successCount++;
          } catch (productError) {
            console.error(`Failed: "${item.name}"`, productError);
          }

          const progress = Math.round(
            ((i + 1) / productsToUpload.length) * 100,
          );
          setUploadProgress(progress);
        }
      }

      setIsUploading(false);

      if (successCount > 0) {
        let message = `Uploaded ${successCount} products`;

        if (skippedProducts.length > 0) {
          message += ` (${skippedProducts.length} skipped due to category issues)`;
        }

        toast.success(message);
        await refreshAllData();
        handleUploadXLSXClose();
      } else {
        let errorMsg = "No products uploaded. ";

        if (skippedProducts.length > 0) {
          const failedCategories = [
            ...new Set(skippedProducts.map((p) => p.category)),
          ];
          errorMsg += `Categories failed: ${failedCategories.join(", ")}`;
        }

        toast.error(errorMsg);
      }
    } catch (error) {
      setIsUploading(false);
      toast.error("Upload process failed");
    }
  };

  const refreshAllData = useCallback(async () => {
    try {
      await dispatch(
        getAllSellerCategories({ page: 1, limit: sellerCategoriesLimit }),
      );

      if (selectedBuyerCategory === "MRP Catalog") {
        await dispatch(getUserProducts({ page: 1, limit: 10000 }));
      } else if (selectedBuyerCategoryId) {
        await dispatch(
          getProductsByBuyerCategoryId({
            buyerCategoryId: selectedBuyerCategoryId,
            page: 1,
            limit: 10000,
          }),
        );
      }
    } catch (refreshError) {
      console.error("Refresh error:", refreshError);
    }
  }, [
    dispatch,
    sellerCategoriesLimit,
    selectedBuyerCategory,
    selectedBuyerCategoryId,
  ]);

  const handleAddProductOpen = () => {
    setNewProduct({
      name: "",
      category: "",
      mrp: "",
      unit: "",
      customUnit: "",
      description: "",
      specifications: "",
      image: "",
      imageFile: null,
    });
    setOpenAddProduct(true);
  };

  const handleAddProductClose = () => {
    setOpenAddProduct(false);
    setNewProduct({
      name: "",
      category: "",
      mrp: "",
      unit: "",
      customUnit: "",
      description: "",
      specifications: "",
      image: "",
      imageFile: null,
    });
  };

  const handleAddProductChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewProduct((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddProductSubmit = async (e) => {
    e.preventDefault();
    if (!newProduct.name || !newProduct.category || !newProduct.mrp) {
      toast.warning("Please fill all required fields");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("name", newProduct.name);
      formData.append("category", newProduct.category);
      formData.append("mrp", newProduct.mrp);
      const finalUnit =
        newProduct.unit === "Other" ? newProduct.customUnit : newProduct.unit;
      formData.append("unit", finalUnit || "Pcs");
      formData.append("description", newProduct.description || "");
      formData.append("specifications", newProduct.specifications || "");
      formData.append("user", user?._id);
      // IMAGE HANDLING
      if (newProduct.imageFile) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          formData.append("image", reader.result);
          for (let [key, value] of formData.entries()) {
            if (
              key === "image" &&
              value &&
              typeof value === "string" &&
              value.length > 100
            ) {
            } else {
              console.log(`${key}: ${value}`);
            }
          }
          try {
            await dispatch(addProduct(formData)).unwrap();
            await refreshAllData();
            toast.success("Product added successfully");
            handleAddProductClose();
          } catch (err) {
            toast.error(err?.message || "Failed to add product");
          }
        };
        reader.readAsDataURL(newProduct.imageFile);
        return;
      } else if (newProduct.image) {
        formData.append("image", newProduct.image);
      } else {
        formData.append("image", "");
      }
      await dispatch(addProduct(formData)).unwrap();
      await refreshAllData();
      toast.success("Product added successfully");
      handleAddProductClose();
    } catch (err) {
      toast.error(err?.message || "Failed to add product");
    }
  };
  const handleEditProductOpen = (product) => {
    const buyerProduct = allProductsLoaded?.find((p) => p._id === product._id);
    const priceToShow = buyerProduct?.buyerCategory?.price ?? product.price;
    const isCustomUnit = !["kgs", "meters", "pieces"].includes(
      product.unit?.toLowerCase(),
    );
    const displayUnit = isCustomUnit ? "other" : product.unit || "";

    setEditProduct({
      ...product,
      price: priceToShow,
      unit: displayUnit,
      customUnit: isCustomUnit ? product.unit : "",
    });

    setEditProductId(product?._id);
    setOpenEditProduct(true);
    setAnchorEl(null);
    setActionProductId(null);
  };

  const handleEditProductClose = async () => {
    setOpenEditProduct(false);
    setEditProductId(null);
    setEditProduct({
      name: "",
      category: "",
      price: "",
      unit: "",
      customUnit: "",
      mrp: "",
    });
    await refreshAllData();
  };

  const handleEditProductChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "unit") {
      setEditProduct((prev) => ({
        ...prev,
        unit: value,
        customUnit: value === "other" ? prev.customUnit : "",
      }));
    } else {
      setEditProduct((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleEditProductSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!editProduct.name || !editProduct.category) {
        toast.warning("Please fill all required fields");
        return;
      }
      const categoryId = editProduct.category?._id || editProduct.category;
      if (!categoryId) {
        toast.warning("Please select valid categories");
        return;
      }
      const finalUnit =
        editProduct.unit === "other"
          ? editProduct.customUnit
          : editProduct.unit;
      const formData = new FormData();
      formData.append("name", editProduct.name || "");
      formData.append("unit", finalUnit);
      formData.append("category", categoryId);
      formData.append("mrp", editProduct.mrp?.toString() || "0");
      formData.append("user", user?._id || "");
      formData.append("description", editProduct.description || "");
      formData.append("specifications", editProduct.specifications || "");

      if (selectedBuyerCategory !== "MRP Catalog" && selectedBuyerCategoryId) {
        formData.append("buyerCategory", selectedBuyerCategoryId);
      }

      if (editProduct.imageFile) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          formData.append("image", reader.result);
          try {
            await dispatch(
              updateProduct({ id: editProductId, formData }),
            ).unwrap();
            await refreshAllData();
            handleEditProductClose();

            if (editProduct.image && editProduct.image.startsWith("blob:")) {
              URL.revokeObjectURL(editProduct.image);
            }
          } catch (err) {
            toast.error(err?.message || "Failed to update product");
          }
        };
        reader.readAsDataURL(editProduct.imageFile);
        return;
      }

      if (editProduct.image) {
        formData.append("image", editProduct.image);
      }
      await dispatch(updateProduct({ id: editProductId, formData })).unwrap();
      await refreshAllData();
      handleEditProductClose();
      toast.success("Product updated successfully");
    } catch (err) {
      toast.error(err?.message || "Failed to update product");
    }
  };

  const handleActionsMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActionProductId(id);
  };

  const handleActionsMenuClose = () => {
    setAnchorEl(null);
    setActionProductId(null);
  };

  const handleToggleProductVisible = async (productId) => {
    try {
      const product = allProductsLoaded?.find((p) => p._id === productId);

      if (!product || !product.buyerCategory) {
        toast.info("Product not found in buyer category");
        return;
      }

      const currentVisibility = product.buyerCategory.visible ?? false;
      const newVisibility = !currentVisibility;

      await dispatch(
        updateProductBuyerCategoryVisibility({
          productId,
          buyerCategory: selectedBuyerCategoryId,
          visible: newVisibility,
        }),
      ).unwrap();

      await refreshAllData();
      toast.success("Visibility updated successfully!");
    } catch (error) {
      toast.error(
        "Failed to update visibility: " + (error.message || "Unknown error"),
      );
    }
  };

  const handleDeleteProduct = (id, productName) => {
    setConfirmDialog({
      open: true,
      title: "Delete Product",
      content: `Are you sure you want to delete "${productName}"?`,
      onConfirm: () => performDeleteProduct(id),
      severity: "error",
      confirmText: "Delete",
    });
    handleActionsMenuClose();
  };

  const performDeleteProduct = async (id) => {
    try {
      await dispatch(deleteProduct(id)).unwrap();
      await refreshAllData();
      setConfirmDialog((prev) => ({ ...prev, open: false }));
      toast.success("Product deleted successfully!");
    } catch (err) {
      toast.error(err?.message || "Failed to delete product");
      setConfirmDialog((prev) => ({ ...prev, open: false }));
    }
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialog((prev) => ({ ...prev, open: false }));
  };

  const handleHideProducts = async (buyerCategoryId, productCategoryId) => {
    try {
      if (!buyerCategoryId || !productCategoryId) {
        toast.warning("Please select both buyer category and product category");
        return;
      }
      const res = await dispatch(
        hideProductsByBuyerCategory({
          buyerCategoryId,
          productCategoryId: selectedSellerCategory._id,
        }),
      );

      if (res?.payload?.success) {
        toast.success(
          res.payload.message || "Visibility updated successfully!",
        );
        await refreshAllData();
      } else {
        toast.error(res?.payload?.message || "Something went wrong!");
      }
    } catch (error) {
      toast.error("Failed to update visibility!");
    }
  };

  const calculateRowNumber = (index) => {
    return (page - 1) * limit + index + 1;
  };

  const handleChangePriceOpen = (product) => {
    setChangePriceProduct(product);
    setNewPrice(product.buyerCategory?.price?.toString() || "");
    setOpenChangePrice(true);
    handleActionsMenuClose();
  };

  const handleChangePriceClose = () => {
    setOpenChangePrice(false);
    setChangePriceProduct(null);
    setNewPrice("");
  };

  const handleChangePriceSubmit = async (e) => {
    e.preventDefault();

    if (!changePriceProduct || !newPrice || isNaN(newPrice)) {
      toast.warning("Please enter a valid price");
      return;
    }

    if (parseFloat(newPrice) <= 0) {
      toast.warning("Price must be greater than 0");
      return;
    }

    try {
      await dispatch(
        updateProductBuyerCategoryVisibility({
          productId: changePriceProduct._id,
          buyerCategory: selectedBuyerCategoryId,
          price: parseFloat(newPrice),
          visible: changePriceProduct.buyerCategory?.visible ?? true,
        }),
      ).unwrap();

      toast.success("Price updated successfully!");
      await refreshAllData();
      handleChangePriceClose();
    } catch (error) {
      toast.error(
        "Failed to update price: " + (error.message || "Unknown error"),
      );
    }
  };

  // Handle Global Discount dialog
  const handleGlobalDiscountOpen = () => {
    if (!selectedBuyerCategoryId || !selectedSellerCategory?._id) {
      toast.warning("Please select both buyer category and product category");
      return;
    }
    // Pre-fill with current average discount
    setDiscountPercentage(currentAverageDiscount);
    setOpenGlobalDiscount(true);
  };

  const handleGlobalDiscountClose = () => {
    setOpenGlobalDiscount(false);
    setDiscountPercentage(0);
  };

  const handleApplyGlobalDiscount = async () => {
    if (discountPercentage < 0 || discountPercentage > 100) {
      toast.warning("Discount must be between 0% and 100%");
      return;
    }

    try {
      const payload = {
        buyerCategoryId: selectedBuyerCategoryId,
        productCategoryId: selectedSellerCategory._id,
        discount: discountPercentage,
      };

      await dispatch(applyGlobalDiscount(payload)).unwrap();

      toast.success(
        `Global discount of ${discountPercentage}% applied successfully!`,
      );
      await refreshAllData();
      handleGlobalDiscountClose();
    } catch (error) {
      toast.error(
        "Failed to apply global discount: " +
          (error.message || "Unknown error"),
      );
    }
  };

  return (
    <>
      <PageTitle
        title="Catalog Management - BizBridge"
        description="Manage your product catalog efficiently. Add, update and organize products, pricing, and categories to grow your B2B business on BizBridge."
        keywords="catalog management, product catalog, seller dashboard, manage products, B2B catalog, product listing, inventory management, BizBridge seller"
        url="/seller-dashboard/catalog-management"
      />

      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          background: "#f8fafc",
          py: { xs: 1, sm: 2 },
        }}
      >
        {/* Breadcrumb */}
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            width: "fit-content",
            backgroundColor: "#fff",
            ml: { xs: 1, sm: 2.9 },
            padding: "13px",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <MUILink
            component={Link}
            to="/seller-dashboard/product-category"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Product Category
          </MUILink>
          <Typography sx={{ color: "#0b4064", fontWeight: "bold" }}>
            Catalog Management
          </Typography>
        </Breadcrumbs>

        <Divider sx={{ my: 2 }} />
        <Box sx={{ maxWidth: 1350, mx: "auto", px: { xs: 2, sm: 3 } }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              flexDirection: { xs: "column", md: "row" },
              mb: 3,
              gap: 2,
            }}
          >
            <Typography fontWeight={700} fontSize={22}>
              Catalog Management
            </Typography>

            <Grid
              container
              spacing={1.5}
              sx={{
                width: { xs: "100%", md: "auto" },
                justifyContent: { xs: "flex-start", sm: "flex-end" },
              }}
            >
              <Grid item xs={12} sm={12} md="auto">
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<FileDownloadIcon />}
                  onClick={handleDownloadSample}
                  sx={{
                    bgcolor: "white",
                    fontWeight: 600,
                    borderColor: "#0b4064",
                    whiteSpace: "nowrap",
                    height: "100%",
                    py: 1,
                  }}
                >
                  Download Sample
                </Button>
              </Grid>

              <Grid item xs={6} sm={12} md="auto">
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<CloudUploadOutlinedIcon />}
                  onClick={handleUploadXLSXOpen}
                  sx={{
                    bgcolor: "white",
                    fontWeight: 600,
                    borderColor: "#0b4064",
                    whiteSpace: "nowrap",
                    height: "100%",
                    py: 1,
                  }}
                >
                  bulk Upload
                </Button>
              </Grid>

              <Grid item xs={6} sm={12} md="auto">
                <Button
                  variant="contained"
                  fullWidth
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={handleAddProductOpen}
                  sx={{
                    bgcolor: "#0b4064",
                    fontWeight: 700,
                    "&:hover": { bgcolor: "#09324d" },
                    whiteSpace: "nowrap",
                    height: "100%",
                    py: 1,
                  }}
                >
                  Add Product
                </Button>
              </Grid>

              {!isMRPCatalogAndAllSelected &&
                selectedBuyerCategoryId &&
                selectedSellerCategory?._id && (
                  <>
                    <Grid item xs={12} sm={12} md="auto">
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<VisibilityOffIcon />}
                        onClick={() =>
                          handleHideProducts(
                            selectedBuyerCategoryId,
                            selectedSellerCategory._id,
                          )
                        }
                        sx={{
                          borderColor: "#f44336",
                          color: "#f44336",
                          "&:hover": {
                            bgcolor: "rgba(244, 67, 54, 0.1)",
                            borderColor: "#f44336",
                          },
                          whiteSpace: "nowrap",
                          height: "100%",
                          py: 1,
                        }}
                      >
                        Hide All
                      </Button>
                    </Grid>

                    <Grid item xs={6} sm={12} md="auto">
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<LocalOfferIcon />}
                        onClick={handleGlobalDiscountOpen}
                        sx={{
                          borderColor: "#4caf50",
                          color: "#4caf50",
                          "&:hover": {
                            bgcolor: "rgba(76, 175, 80, 0.1)",
                            borderColor: "#4caf50",
                          },
                          whiteSpace: "nowrap",
                          height: "100%",
                          py: 1,
                        }}
                      >
                        Change Discount
                      </Button>
                    </Grid>
                  </>
                )}
            </Grid>
          </Box>

          {/* Buyer and Seller Categories */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 3,
              mb: 3,
              alignItems: { xs: "stretch", sm: "center" },
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography variant="body1" fontWeight={600} mb={1}>
                Buyer Category:
              </Typography>
              <Button
                variant="outlined"
                onClick={handleBuyerCategoryDropdownOpen}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{
                  borderRadius: "8px",
                  width: "100%",
                  justifyContent: "space-between",
                  fontWeight: 700,
                  px: 2,
                  bgcolor: "white",
                  textTransform: "none",
                }}
              >
                <Typography
                  noWrap
                  sx={{
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {selectedBuyerCategory}
                </Typography>
              </Button>

              <Menu
                anchorEl={buyerCategoryAnchorEl}
                open={Boolean(buyerCategoryAnchorEl)}
                onClose={handleBuyerCategoryDropdownClose}
                PaperProps={{
                  sx: {
                    maxHeight: 400,
                    width: 250,
                  },
                }}
              >
                <MenuItem
                  onClick={() => handleBuyerCategorySelect("MRP Catalog")}
                  sx={{
                    fontWeight: 700,
                    bgcolor:
                      selectedBuyerCategory === "MRP Catalog"
                        ? "rgba(19, 68, 164, 0.1)"
                        : "white",
                    "&:hover": {
                      bgcolor: "rgba(19, 68, 164, 0.05)",
                    },
                  }}
                >
                  MRP Catalog
                </MenuItem>

                {/* {loadedBuyerCategories?.map((category) => (
                  <MenuItem
                    key={category._id}
                    onClick={() => handleBuyerCategorySelect(category)}
                    sx={{
                      fontWeight: 700,
                      bgcolor:
                        selectedBuyerCategory === category.name
                          ? "rgba(19, 68, 164, 0.1)"
                          : "white",
                      "&:hover": {
                        bgcolor: "rgba(19, 68, 164, 0.05)",
                      },
                    }}
                  >
                    {category.name}
                  </MenuItem>
                ))} */}

                {loadedBuyerCategories?.map((category) => {
                  const displayName =
                    category.name.toLowerCase() === "kiosk"
                      ? "kiosk (Consumer)"
                      : category.name;

                  return (
                    <MenuItem
                      key={category._id}
                      onClick={() => handleBuyerCategorySelect(category)}
                      sx={{
                        fontWeight: 700,
                        bgcolor:
                          selectedBuyerCategory === category.name
                            ? "rgba(19, 68, 164, 0.1)"
                            : "white",
                        "&:hover": {
                          bgcolor: "rgba(19, 68, 164, 0.05)",
                        },
                      }}
                    >
                      {displayName}
                    </MenuItem>
                  );
                })}

                {hasMoreBuyerCategories && (
                  <Box sx={{ p: 1, borderTop: 1, borderColor: "divider" }}>
                    <Button
                      fullWidth
                      onClick={loadMoreBuyerCategories}
                      disabled={buyerCategoriesLoading}
                      sx={{
                        fontWeight: 600,
                        textTransform: "none",
                      }}
                    >
                      {buyerCategoriesLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        `Load More`
                      )}
                    </Button>
                  </Box>
                )}
              </Menu>
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography variant="body1" fontWeight={600} mb={1}>
                Product Category:
              </Typography>
              <Button
                variant="outlined"
                onClick={handleSellerCategoryDropdownOpen}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{
                  borderRadius: "8px",
                  width: "100%",
                  justifyContent: "space-between",
                  fontWeight: 700,
                  px: 2,
                  bgcolor: "white",
                  textTransform: "none",
                }}
              >
                <Typography
                  noWrap
                  sx={{
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {selectedSellerCategory === "All"
                    ? "All"
                    : selectedSellerCategory?.name || "Select Category"}
                </Typography>
              </Button>

              <Menu
                anchorEl={sellerCategoryAnchorEl}
                open={Boolean(sellerCategoryAnchorEl)}
                onClose={handleSellerCategoryDropdownClose}
                PaperProps={{
                  sx: {
                    maxHeight: 400,
                    width: 250,
                  },
                }}
              >
                <MenuItem
                  onClick={() => handleSellerCategorySelect("All")}
                  sx={{
                    fontWeight: 700,
                    bgcolor:
                      selectedSellerCategory === "All"
                        ? "rgba(19, 68, 164, 0.1)"
                        : "white",
                    "&:hover": {
                      bgcolor: "rgba(19, 68, 164, 0.05)",
                    },
                  }}
                >
                  All
                </MenuItem>

                {loadedSellerCategories.map((category) => (
                  <MenuItem
                    key={category._id}
                    onClick={() => handleSellerCategorySelect(category)}
                    sx={{
                      fontWeight: 700,
                      bgcolor:
                        selectedSellerCategory?.name === category.name
                          ? "rgba(19, 68, 164, 0.1)"
                          : "white",
                      "&:hover": {
                        bgcolor: "rgba(19, 68, 164, 0.05)",
                      },
                    }}
                  >
                    {category.image ? (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Avatar
                          src={category.image}
                          sx={{ width: 24, height: 24 }}
                        />
                        {category.name}
                      </Box>
                    ) : (
                      category.name
                    )}
                  </MenuItem>
                ))}

                {hasMoreSellerCategories && (
                  <Box sx={{ p: 1, borderTop: 1, borderColor: "divider" }}>
                    <Button
                      fullWidth
                      onClick={loadMoreSellerCategories}
                      disabled={sellerCategoriesLoading}
                      sx={{
                        fontWeight: 600,
                        textTransform: "none",
                      }}
                    >
                      {sellerCategoriesLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        `Load More`
                      )}
                    </Button>
                  </Box>
                )}
              </Menu>
            </Box>
          </Box>

          {/* Search Bar */}
          <Box
            sx={{
              mb: 3,
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <TextField
                placeholder="Search products by name, category, description..."
                value={searchQuery}
                onChange={handleSearchChange}
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={handleClearSearch}
                        edge="end"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  bgcolor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>

            {searchQuery && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minWidth: { xs: "100%", sm: "auto" },
                }}
              >
                <Chip
                  label={`${filteredProducts.length} product(s) found`}
                  color="primary"
                  variant="outlined"
                  size="small"
                  sx={{ fontWeight: 500 }}
                />
              </Box>
            )}

            {/* Items per page selector */}
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Items</InputLabel>
                <Select
                  value={limit.toString()}
                  label="Items"
                  onChange={handleLimitChange}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: 2,
                  }}
                >
                  <MenuItem value="10">10 per page</MenuItem>
                  <MenuItem value="20">20 per page</MenuItem>
                  <MenuItem value="50">50 per page</MenuItem>
                  <MenuItem value="100">100 per page</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          {/* Product Table */}
          <Box
            sx={{
              overflowX: "auto",
              mb: 3,
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            <TableContainer>
              <Table sx={{ minWidth: 650 }}>
                <TableHead sx={{ bgcolor: "#f8fafc" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Product</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Unit</TableCell>
                    {selectedBuyerCategory === "MRP Catalog" ? (
                      <>
                        <TableCell sx={{ fontWeight: 700 }}>MRP</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell sx={{ fontWeight: 700 }}>MRP</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Price</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productLoading ? (
                    <TableRow>
                      <TableCell
                        colSpan={
                          selectedBuyerCategory === "MRP Catalog" ? 6 : 9
                        }
                        align="center"
                        sx={{ py: 8 }}
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : paginatedProducts?.length > 0 ? (
                    paginatedProducts?.map((product, index) => {
                      const buyerCategoryPrice = product.buyerCategory?.price;
                      const isVisible = product.buyerCategory?.visible ?? false;
                      return (
                        <TableRow
                          key={product._id}
                          sx={{
                            "&:hover": {
                              bgcolor: "rgba(19, 68, 164, 0.02)",
                            },
                          }}
                        >
                          <TableCell>{calculateRowNumber(index)}</TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                cursor: "pointer",
                                "&:hover": {
                                  textDecoration: "underline",
                                  color: "#0b4064",
                                },
                              }}
                              onClick={() =>
                                navigate(
                                  selectedBuyerCategory === "MRP Catalog"
                                    ? `/seller-dashboard/view-product-details/${product._id}`
                                    : `/seller-dashboard/view-product-details/${product._id}`,
                                  { state: { product } },
                                )
                              }
                            >
                              <Avatar
                                variant="rounded"
                                src={product.image || "N/A"}
                                sx={{
                                  width: 40,
                                  height: 40,
                                  bgcolor: "#e7fafc",
                                  color: "#000",
                                  fontWeight: 700,
                                  fontSize: 14,
                                  borderRadius: 2,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexShrink: 0,
                                  textTransform: "uppercase",
                                }}
                              >
                                {product?.name?.substring(0, 2)}
                              </Avatar>

                              <Box sx={{ fontWeight: 500 }}>{product.name}</Box>
                            </Box>
                          </TableCell>
                          <TableCell>{product.category?.name}</TableCell>
                          <TableCell>{product.unit}</TableCell>
                          {selectedBuyerCategory === "MRP Catalog" ? (
                            <>
                              <TableCell>₹{product.mrp?.toFixed(2)}</TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <MenuItem
                                    sx={{ minHeight: "auto", p: 0.5 }}
                                    onClick={() =>
                                      handleEditProductOpen(product)
                                    }
                                  >
                                    <ListItemIcon
                                      sx={{
                                        minWidth: "auto",
                                        color: "#0b4064",
                                      }}
                                    >
                                      <EditIcon fontSize="small" />
                                    </ListItemIcon>
                                  </MenuItem>

                                  <MenuItem
                                    sx={{ minHeight: "auto", p: 0.5 }}
                                    onClick={() =>
                                      handleDeleteProduct(
                                        product._id,
                                        product.name,
                                      )
                                    }
                                  >
                                    <ListItemIcon sx={{ minWidth: "auto" }}>
                                      <DeleteIcon
                                        fontSize="small"
                                        color="error"
                                      />
                                    </ListItemIcon>
                                  </MenuItem>
                                </Box>
                              </TableCell>
                            </>
                          ) : (
                            <>
                              {/* <TableCell>{product.unit}</TableCell> */}
                              <TableCell>₹{product.mrp?.toFixed(2)}</TableCell>
                              <TableCell>
                                {buyerCategoryPrice
                                  ? `₹${buyerCategoryPrice.toFixed(2)}`
                                  : "₹0.00"}
                              </TableCell>

                              <TableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  {/* Visibility Toggle */}
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleToggleProductVisible(product._id)
                                    }
                                  >
                                    {isVisible ? (
                                      <VisibilityIcon
                                        color="primary"
                                        fontSize="small"
                                      />
                                    ) : (
                                      <VisibilityOffIcon
                                        color="action"
                                        fontSize="small"
                                      />
                                    )}
                                  </IconButton>

                                  {/* Change Price */}
                                  {selectedBuyerCategory !== "MRP Catalog" && (
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleChangePriceOpen(product)
                                      }
                                    >
                                      <CurrencyRupeeIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={
                          selectedBuyerCategory === "MRP Catalog" ? 6 : 9
                        }
                        align="center"
                        sx={{ py: 8 }}
                      >
                        <Box sx={{ textAlign: "center" }}>
                          <Typography
                            variant="body1"
                            color="text.secondary"
                            gutterBottom
                          >
                            {searchQuery
                              ? `No products found for "${searchQuery}"`
                              : "No products found"}
                          </Typography>
                          {searchQuery && (
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={handleClearSearch}
                              sx={{ mt: 2 }}
                            >
                              Clear Search
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Pagination */}
          {totalPages > 1 && filteredProducts.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 3,
                mb: 3,
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Showing {(page - 1) * limit + 1} to{" "}
                {Math.min(page * limit, filteredProducts.length)} of{" "}
                {filteredProducts.length} products
              </Typography>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size={isMobile ? "small" : "medium"}
                showFirstButton
                showLastButton
              />
            </Box>
          )}
        </Box>

        {/* Upload XLSX Dialog */}
        <Dialog
          open={openUploadXLSX}
          onClose={handleUploadXLSXClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            Upload Excel File
            <IconButton
              onClick={handleUploadXLSXClose}
              sx={{ position: "absolute", right: 12, top: 12 }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ px: { xs: 1, sm: 3 }, py: 2 }} dividers>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Typography variant="body2" color="text.secondary">
                Upload an Excel file (.xlsx) with the following columns: name,
                category, mrp, description, specifications, image, unit
              </Typography>

              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUploadOutlinedIcon />}
                sx={{ py: 1.5 }}
              >
                Select Excel File
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  hidden
                  onChange={handleXLSXFileSelect}
                />
              </Button>

              {xlsxFile && (
                <Typography variant="body2">
                  Selected file: {xlsxFile.name}
                </Typography>
              )}

              {xlsxData.length > 0 && (
                <Box>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Found {xlsxData.length} products to upload:
                  </Typography>
                  <Box
                    sx={{
                      maxHeight: 200,
                      overflow: "auto",
                      border: "1px solid #ddd",
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    {xlsxData.map((product, index) => (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{ fontSize: "0.8rem", py: 0.5 }}
                      >
                        • {product.name} - {product.category} - ₹{product.mrp}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              )}

              {isUploading && (
                <Box sx={{ width: "100%" }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Uploading... {uploadProgress}%
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: 8,
                      bgcolor: "#f0f0f0",
                      borderRadius: 4,
                    }}
                  >
                    <Box
                      sx={{
                        width: `${uploadProgress}%`,
                        height: "100%",
                        bgcolor: "#0b4064",
                        borderRadius: 4,
                        transition: "width 0.3s ease",
                      }}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleUploadXLSXClose} disabled={isUploading}>
              Cancel
            </Button>
            <Button
              onClick={handleBulkUpload}
              variant="contained"
              disabled={!xlsxData.length || isUploading}
            >
              {isUploading ? "Uploading..." : "Upload Products"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add Product Dialog */}
        <Dialog
          open={openAddProduct}
          onClose={handleAddProductClose}
          fullWidth
          maxWidth="sm"
          scroll="body"
        >
          <DialogTitle>
            Add Product
            <IconButton
              onClick={handleAddProductClose}
              sx={{ position: "absolute", right: 12, top: 12 }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ px: { xs: 1, sm: 3 }, py: 2 }} dividers>
            <Box
              component="form"
              onSubmit={handleAddProductSubmit}
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              <FormControl fullWidth size="small">
                <InputLabel>Product Category *</InputLabel>
                <Select
                  label="Product Category *"
                  name="category"
                  value={newProduct.category}
                  onChange={handleAddProductChange}
                  required
                >
                  {loadedSellerCategories.map((cat) => (
                    <MenuItem key={cat._id} value={cat._id}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Product Name"
                name="name"
                value={newProduct.name}
                onChange={handleAddProductChange}
                required
                fullWidth
                size="small"
              />

              <TextField
                label="Unit"
                name="unit"
                value={newProduct.unit}
                onChange={handleAddProductChange}
                select
                fullWidth
                size="small"
              >
                <MenuItem value="Kgs">Kgs</MenuItem>
                <MenuItem value="Meters">Meters</MenuItem>
                <MenuItem value="Pieces">Pieces</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>

              {newProduct.unit === "other" && (
                <TextField
                  label="Enter Unit"
                  name="customUnit"
                  value={newProduct.customUnit}
                  onChange={handleAddProductChange}
                  fullWidth
                  size="small"
                  placeholder="Type your custom unit"
                />
              )}

              <TextField
                label="MRP"
                name="mrp"
                value={newProduct.mrp}
                onChange={handleAddProductChange}
                type="number"
                required
                fullWidth
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">₹</InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Description"
                name="description"
                value={newProduct.description}
                onChange={handleAddProductChange}
                multiline
                rows={3}
                fullWidth
                size="small"
                placeholder="Optional"
              />

              <TextField
                label="Specifications"
                name="specifications"
                value={newProduct.specifications}
                onChange={handleAddProductChange}
                multiline
                rows={3}
                fullWidth
                size="small"
                placeholder="Optional"
              />

              <TextField
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const objectUrl = URL.createObjectURL(file);
                    setNewProduct((prev) => ({
                      ...prev,
                      image: objectUrl,
                      imageFile: file,
                    }));
                  } else {
                    setNewProduct((prev) => ({
                      ...prev,
                      image: "",
                      imageFile: null,
                    }));
                  }
                }}
                fullWidth
                size="small"
              />

              {/* Preview */}
              {newProduct.image && (
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: 2,
                    overflow: "hidden",
                    mt: 1,
                  }}
                >
                  <img
                    src={newProduct.image}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              )}

              {/* Preview */}
              {editProduct.image && (
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: 2,
                    overflow: "hidden",
                    mt: 1,
                  }}
                >
                  <img
                    src={editProduct.image}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              )}

              <DialogActions sx={{ px: 0 }}>
                <Button onClick={handleAddProductClose}>Cancel</Button>
                <Button type="submit" variant="contained">
                  Save Changes
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Edit Product Dialog */}
        <Dialog
          open={openEditProduct}
          onClose={handleEditProductClose}
          fullWidth
          maxWidth="sm"
          scroll="body"
        >
          <DialogTitle>
            Edit Product
            <IconButton
              onClick={handleEditProductClose}
              sx={{ position: "absolute", right: 12, top: 12 }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ px: { xs: 1, sm: 3 }, py: 2 }} dividers>
            <Box
              component="form"
              onSubmit={handleEditProductSubmit}
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              {/* Seller Categories with Pagination */}
              <FormControl fullWidth size="small">
                <InputLabel id="edit-product-category-label">
                  Category *
                </InputLabel>
                <Select
                  labelId="edit-product-category-label"
                  label="Category *"
                  value={editProduct.category?.name || ""}
                  onChange={(e) => {
                    const selectedCategory = loadedSellerCategories.find(
                      (cat) => cat.name === e.target.value,
                    );
                    if (selectedCategory) {
                      setEditProduct((prev) => ({
                        ...prev,
                        category: selectedCategory,
                      }));
                    }
                  }}
                  required
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                      },
                    },
                  }}
                >
                  {/* Loaded seller categories */}
                  {loadedSellerCategories.map((cat) => (
                    <MenuItem key={cat._id} value={cat.name}>
                      {cat.name}
                    </MenuItem>
                  ))}

                  {/* Load more button for pagination */}
                  {hasMoreSellerCategories && (
                    <Box sx={{ p: 1, borderTop: 1, borderColor: "divider" }}>
                      <Button
                        fullWidth
                        onClick={(e) => {
                          e.stopPropagation();
                          loadMoreSellerCategories();
                        }}
                        disabled={sellerCategoriesLoading}
                        sx={{
                          color: "#0b4064",
                          fontWeight: 600,
                          textTransform: "none",
                        }}
                      >
                        {sellerCategoriesLoading ? (
                          <CircularProgress size={20} />
                        ) : (
                          `Load More (${
                            sellerCategoriesTotal -
                            loadedSellerCategories.length
                          } more)`
                        )}
                      </Button>
                    </Box>
                  )}

                  {/* Pagination info */}
                  <Box
                    sx={{
                      p: 1,
                      borderTop: 1,
                      borderColor: "divider",
                      textAlign: "center",
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      Page {sellerCategoriesCurrentPage} of{" "}
                      {sellerCategoriesTotalPages}
                    </Typography>
                  </Box>
                </Select>
              </FormControl>

              {/* Product Name */}
              <TextField
                label="Product Name"
                name="name"
                value={editProduct.name}
                onChange={handleEditProductChange}
                required
                fullWidth
                size="small"
              />

              {/* Unit Selection */}
              <TextField
                label="Unit"
                name="unit"
                value={editProduct.unit || ""}
                onChange={handleEditProductChange}
                select
                fullWidth
                size="small"
              >
                <MenuItem value="Kgs">Kgs</MenuItem>
                <MenuItem value="Meters">Meters</MenuItem>
                <MenuItem value="Pieces">Pieces</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>

              {/* Custom unit field appears only when "other" selected */}
              {editProduct.unit === "Other" && (
                <TextField
                  label="Enter Unit"
                  name="customUnit"
                  value={editProduct.customUnit}
                  onChange={handleEditProductChange}
                  fullWidth
                  size="small"
                  placeholder="Type your custom unit"
                  required={editProduct.unit === "other"}
                />
              )}

              <TextField
                label="MRP"
                name="mrp"
                value={editProduct.mrp}
                onChange={handleEditProductChange}
                type="number"
                required
                fullWidth
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">₹</InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Description"
                name="description"
                value={editProduct.description}
                onChange={handleEditProductChange}
                multiline
                rows={3}
                fullWidth
                size="small"
                placeholder="Optional"
              />

              <TextField
                label="Specifications"
                name="specifications"
                value={editProduct.specifications}
                onChange={handleEditProductChange}
                multiline
                rows={3}
                fullWidth
                size="small"
                placeholder="Optional"
              />

              <TextField
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const objectUrl = URL.createObjectURL(file);
                    setEditProduct((prev) => ({
                      ...prev,
                      image: objectUrl,
                      imageFile: file,
                    }));
                  } else {
                    setEditProduct((prev) => ({
                      ...prev,
                      image: "",
                      imageFile: null,
                    }));
                  }
                }}
                fullWidth
                size="small"
              />

              {/* Preview */}
              {editProduct.image && (
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: 2,
                    overflow: "hidden",
                    mt: 1,
                  }}
                >
                  <img
                    src={editProduct.image}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              )}

              <DialogActions sx={{ px: 0 }}>
                <Button onClick={handleEditProductClose}>Cancel</Button>
                <Button type="submit" variant="contained">
                  Save Changes
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Change Price Dialog */}
        <Dialog
          open={openChangePrice}
          onClose={handleChangePriceClose}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CurrencyRupeeIcon fontSize="small" />
              Change Price
            </Box>
            <IconButton
              onClick={handleChangePriceClose}
              sx={{ position: "absolute", right: 12, top: 12 }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ px: { xs: 1, sm: 3 }, py: 3 }} dividers>
            <Box
              component="form"
              onSubmit={handleChangePriceSubmit}
              sx={{ display: "flex", flexDirection: "column", gap: 3 }}
            >
              <Box>
                <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                  {changePriceProduct?.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Category: {changePriceProduct?.category?.name}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  bgcolor: "#f5f5f5",
                  p: 2,
                  borderRadius: 1,
                }}
              >
                <Box>
                  <Typography variant="body2" color="text.secondary">
                    MRP
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    ₹{changePriceProduct?.mrp?.toFixed(2)}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: "right" }}>
                  <Typography variant="body2" color="text.secondary">
                    Current Price
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    ₹
                    {changePriceProduct?.buyerCategory?.price?.toFixed(2) ||
                      "0.00"}
                  </Typography>
                </Box>
              </Box>
              <TextField
                label="Enter New Price"
                value={newPrice}
                onChange={(e) => setNewPrice(e.target.value)}
                type="number"
                required
                fullWidth
                size="medium"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography fontWeight="bold">₹</Typography>
                    </InputAdornment>
                  ),
                  sx: { fontSize: "1.1rem", fontWeight: "bold" },
                }}
                helperText="Price for this specific buyer category"
                sx={{
                  "& .MuiInputBase-input": {
                    fontWeight: "bold",
                  },
                }}
              />

              {changePriceProduct?.buyerCategory?.discount && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#e8f5e9",
                    p: 1.5,
                    borderRadius: 1,
                  }}
                >
                  <DiscountIcon color="success" sx={{ mr: 1 }} />
                  <Typography variant="body2" color="success.main">
                    Current discount:{" "}
                    {changePriceProduct?.buyerCategory?.discount}%
                  </Typography>
                </Box>
              )}

              <DialogActions sx={{ px: 0, pt: 2 }}>
                <Button
                  onClick={handleChangePriceClose}
                  variant="outlined"
                  sx={{ minWidth: 100 }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    minWidth: 100,
                    bgcolor: "#0b4064",
                    "&:hover": {
                      bgcolor: "#09324d",
                    },
                  }}
                >
                  Update Price
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Global Discount Dialog */}
        <Dialog
          open={openGlobalDiscount}
          onClose={handleGlobalDiscountClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalOfferIcon />
              Apply Change Discount
            </Box>
            <IconButton
              onClick={handleGlobalDiscountClose}
              sx={{ position: "absolute", right: 12, top: 12 }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ px: { xs: 1, sm: 3 }, py: 3 }} dividers>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Alert severity="info" sx={{ mb: 2 }}>
                This discount will be applied to all products in the selected
                category for the selected buyer category.
              </Alert>

              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  gutterBottom
                >
                  Selected Categories: {selectedBuyerCategory}
                </Typography>
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                  <Chip
                    label={`Buyer: ${selectedBuyerCategory}`}
                    color="primary"
                    variant="outlined"
                  />
                  <Chip
                    label={`Product: ${selectedSellerCategory?.name}`}
                    color="secondary"
                    variant="outlined"
                  />
                </Box>
              </Box>
              <Box>
                <Typography gutterBottom fontWeight="medium">
                  Discount Percentage
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Slider
                    value={discountPercentage}
                    onChange={(e, value) => setDiscountPercentage(value)}
                    min={0}
                    max={100}
                    step={0.5}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) => `${value}%`}
                    sx={{ flex: 1 }}
                  />
                  <TextField
                    value={discountPercentage}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      if (!isNaN(value) && value >= 0 && value <= 100) {
                        setDiscountPercentage(value);
                      }
                    }}
                    type="number"
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                      inputProps: {
                        min: 0,
                        max: 100,
                        step: 0.5,
                      },
                    }}
                    sx={{ width: 100 }}
                  />
                </Box>
                <Typography variant="caption" color="text.secondary">
                  Set discount between 0% and 100%
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Discount Preview:
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 2,
                    bgcolor: "#f9f9f9",
                    p: 2,
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="body2">MRP: ₹1,000</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    Discounted: ₹
                    {((1000 * (100 - discountPercentage)) / 100).toFixed(2)}
                  </Typography>
                  <Typography variant="body2">You Save:</Typography>
                  <Typography
                    variant="body2"
                    color="success.main"
                    fontWeight="bold"
                  >
                    ₹{((1000 * discountPercentage) / 100).toFixed(2)} (
                    {discountPercentage}%)
                  </Typography>
                </Box>
              </Box>

              <DialogActions sx={{ px: 0, pt: 2 }}>
                <Button
                  onClick={handleGlobalDiscountClose}
                  variant="outlined"
                  sx={{ minWidth: 100 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleApplyGlobalDiscount}
                  variant="contained"
                  color="success"
                  startIcon={<LocalOfferIcon />}
                  sx={{ minWidth: 150 }}
                >
                  Apply Discount
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Confirm Dialog for Delete */}
        <ConfirmDialog
          open={confirmDialog.open}
          title={confirmDialog.title}
          content={confirmDialog.content}
          onConfirm={confirmDialog.onConfirm}
          onClose={handleConfirmDialogClose}
        />
      </Box>
    </>
  );
}
